import {createSlice, PayloadAction} from '@reduxjs/toolkit';
import {identitiesApi} from '../../app/services/identitiesApi';
import {logout} from '../auth/authSlice';

export interface DemoState {
  limitReached: {
    closable?: boolean;
    message?: string;
    title?: string;
    warning?: string;
  } | null;
}

export const initialState: DemoState = {
  limitReached: null,
};

const demoSlice = createSlice({
  name: 'demo',
  initialState,
  reducers: {
    setLimitReached: (state, action: PayloadAction<DemoState['limitReached']>) => {
      state.limitReached = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(logout, () => {
      return initialState;
    });
    builder.addMatcher(identitiesApi.endpoints.registerVerifyOTP.matchFulfilled, () => {
      return initialState;
    });
  },
});

export const {setLimitReached} = demoSlice.actions;

export const selectLimitReached = (state: {demo: DemoState}) => state.demo.limitReached;

export default demoSlice.reducer;
